import { clone } from 'lodash';

interface Configuration {
  has_auth_header: boolean;
  has_awin: boolean;
  has_evo: boolean;
  has_coupon: boolean;
  has_hmac: boolean;
  is_aggregated_payout: boolean;
  is_external_ventilation: boolean;
  main_source_transaction: string;
  manual_threshold_pool: any;
}

export class Program {
  id: string;
  name: string;
  description: string;
  legal_terms: string;
  billing_address: string;
  country = 'FR';
  configuration: Configuration;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}

export function fromApi(data) {
  data = clone(data);

  return data;
}

export function toApi(data) {
  data = clone(data);

  return data;
}
